import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/__authenticated/clients')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/__authenticated/clients"!</div>;
}
